import PropTypes from 'prop-types';
import React, {Component} from 'react';
import axios from 'axios';
import * as R from 'ramda';
import CsvUploadForm from 'js/components/csv_upload_form';
import Papa from 'papaparse';

export default class CsvUploader extends Component {
    static propTypes = {
        errorMessageBuilder: PropTypes.func,
        validate: PropTypes.func.isRequired
    };

    static defaultProps = {
        buttonText: 'Upload CSV',
        validate: R.always(true),
        errorMessageBuilder: R.always(null),
        successMessageBuilder: R.always(null)
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isErrored: false,
            message: null
        };
    }

    handleUploadFile = async e => {
        this.setState({
            isLoading: true,
            isErrored: false,
            message: null
        });

        try {
            const csvFile = e.target[0].files[0];

            const parsed = await new Promise((resolve, reject) => {
                Papa.parse(csvFile, {
                    header: true,
                    complete: ({data, errors}) => {
                        if (errors && errors.length) {
                            return reject(errors[0]);
                        }

                        return resolve(data);
                    }
                });
            });

            if (!parsed) {
                throw new Error('Unable to parse CSV');
            }

            this.props.validate(parsed);
            const formData = new FormData();
            formData.append('csv', csvFile);

            const {url, successMessageBuilder} = this.props;
            const result = await axios.post(url, formData);
            const {data} = result;
            const message = successMessageBuilder(data) || data.message || data;
            this.setState({message});
        } catch (error) {
            console.error(error);
            const {errorMessageBuilder} = this.props;
            if (error.data) {
                const {data} = error;
                const errorMessage = errorMessageBuilder(data) || data.message || data;
                this.setState({
                    message: errorMessage,
                    isErrored: true
                });
            } else {
                this.setState({
                    message: error.message,
                    isErrored: true
                });
            }
        }
        this.setState({
            isLoading: false
        });
    };

    render() {
        const passOnProps = R.pick(['children', 'buttonText'], this.props);
        const passOnState = R.pick(
            ['isLoading', 'noFileSelected', 'isErrored', 'message'],
            this.state
        );
        return <CsvUploadForm {...passOnProps} {...passOnState} onSubmit={this.handleUploadFile} />;
    }
}



// WEBPACK FOOTER //
// ./components/csv_uploader.js